module.exports = __webpack_public_path__ + "img/cxTrends-mini-1.8c2f1ef7.png";